import { magenta } from "@ant-design/colors";
import MiniInfoCard from "@lib/components/MiniComponents/Dashboard/MiniInfoCard";
import { FormattedMessage, useIntl } from "react-intl";
import dayjs from "dayjs";
import { FiShoppingCart } from "react-icons/fi";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useOrderQueries, useProductQueries } from "@lib/apiQueries";
import { ROUTES } from "@lib/constants";
import { AppCardProps } from "@lib/components/AppComponents/AppCard";

type Props = {
  cardProps?: AppCardProps;
};

export default function ProductMiniCard(props: Props) {
  const { cardProps } = props;
  const { messages } = useIntl();
  const navigate = useNavigate();

  const { productsQuery } = useProductQueries({
    messages,
    queryKey: ["dashboard-minicard-products"],
    params: {
      limit: 1000,
    },
  });
  const { data, isLoading } = productsQuery;
  const total = data?.data?.count;

  const { ordersQuery } = useOrderQueries({
    messages,
    queryKey: ["dashboard-minicard-orders"],
    params: {
      limit: 1000,
      s: [
        {
          $and: [
            { createdAt: { $gte: dayjs().startOf("month").format() } },
            { createdAt: { $lte: dayjs().endOf("month").format() } },
          ],
        },
      ],
    },
  });
  const { data: orderData, isLoading: orderIsLoading } = ordersQuery;

  const totalOrder = useMemo(() => {
    let count = 0;
    for (let index = 0; index < orderData?.data?.data?.length; index++) {
      const item = orderData?.data?.data[index];
      count += Number(item?.quantity || 0);
    }
    return count;
  }, [orderData]);

  const handleNavigate = () => {
    navigate(ROUTES.PRODUCT.LIST);
  };

  return (
    <MiniInfoCard
      loading={isLoading || orderIsLoading}
      navigate={handleNavigate}
      cardProps={cardProps}
      data={{
        icon: <FiShoppingCart />,
        color: magenta[6],
        desc: (
          <FormattedMessage
            id="common.totalX"
            values={{ x: messages["common.product"] as string }}
          />
        ),
        title: total,
        rightMenu: {
          key: "new",
          data: {
            data: totalOrder || 0,
            duration: messages["common.thisMonthsOrder"] as string,
            title: messages["common.order"] as string,
          },
        },
      }}
    />
  );
}
